import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
let SubCategoryModel = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('number'), _dec4 = belongsTo('category', {
  inverse: 'sub_categories',
  async: false
}), _dec5 = attr('boolean', {
  defaultValue: false
}), _class = class SubCategoryModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "rank", _descriptor2, this);
    _initializerDefineProperty(this, "iva_det", _descriptor3, this);
    _initializerDefineProperty(this, "category", _descriptor4, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "iva_det", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "category", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { SubCategoryModel as default };
//# sourceMappingURL=sub-category.js.map
